import {Option} from './option';
import {Ad} from './ad';
export class OptionGroup {
  id: number;
  sceneId: number;
  displayName: string;
  filePath: string;
  options: Array<Option> = Array<Option>();
  ads: Array<Ad> = Array<Ad>();
  expanded = true;

  static fromJSON(json: OptionGroupJSON): OptionGroup {
    const optionGroup = Object.assign(Object.create(OptionGroup.prototype), json, {
      options: JSON.parse(json.options),
      ads: JSON.parse(json.ads)
    });

    optionGroup.options = [];
    const optionArray = JSON.parse(json.options);
    for (const option of optionArray) {
      optionGroup.options.push(Option.fromJSON(option));
    }

    optionGroup.ads = [];
    const adsArray = JSON.parse(json.ads);
    for (const ad of adsArray) {
      optionGroup.ads.push(Ad.fromJSON(ad));
    }

    return optionGroup;
  }

  toJSON(): OptionGroupJSON {
    return Object.assign({}, this, {
      options: JSON.stringify(this.options),
      ads: JSON.stringify(this.ads)
    });
  }

  constructor(public data: any, sId: number) {
    const json: JSON = data;

    this.id = json['id'];
    this.sceneId = sId;
    this.displayName = json['displayName'];
    this.filePath = json['src'];

    const optionsListJSON: any[] = json['options'];
    if (optionsListJSON != null) {
      for (const key in Object.keys(optionsListJSON)) {
        if (optionsListJSON.hasOwnProperty(key)) {
          this.options.push(new Option(optionsListJSON[key], this.id, this.sceneId));
        }
      }
    }

    if (json['advertising']) {
      for (const ad of json['advertising']['adverts']) {
        this.ads.push(new Ad(ad));
      }
    }
  }

  findOptionById(optionId: number) {
    for (const option of this.options) {
      if (option.id === optionId) {
        return option;
      }
    }
    return null;
  }
}

interface OptionGroupJSON {
  sceneId: number;
  displayName: string;
  filePath: string;
  options: string;
  ads: string;
}



// WEBPACK FOOTER //
// ./src/app/model/option-group.ts